import React, { useState, useEffect } from 'react';
import { useTransition, animated } from 'react-spring'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import react from '../Assets/logo.svg';
import flutter from '../Assets/flutter.png';
import iphone from '../Assets/app.svg';
import android from '../Assets/androidLogo.svg';
import rails from '../Assets/rails.png';


const pages = [
    ({ style }) => <animated.div style={{ ...style, background: 'lightslategray' }}><img src={react} className="autoCard" />React</animated.div>,
    ({ style }) => <animated.div style={{ ...style, background: 'lightblue' }}><img src={flutter} className="autoCard" />Flutter</animated.div>,
    ({ style }) => <animated.div style={{ ...style, background: 'lightskyblue' }}><img src={iphone} className="autoCard" />IOS</animated.div>,
    ({ style }) => <animated.div style={{ ...style, background: 'lightgreen' }}><img src={android} className="autoCard" />Android</animated.div>,
    ({ style }) => <animated.div style={{ ...style, background: 'lightgray' }}><img src={rails} className="autoCard" />Rails</animated.div>,
  ]

function Pricing(){
    const [index, set] = useState(0)
    const onClick = useEffect(() => void setInterval(() => set(state => (state + 1) % 5), 3000),  [])
    const transitions = useTransition(index, p => p, {
      from: { opacity: 0, transform: 'translate3d(100%,0,0)' },
      enter: { opacity: 1, transform: 'translate3d(0%,0,0)' },
      leave: { opacity: 0, transform: 'translate3d(-50%,0,0)' },
    })
    return(
        <Row className="spacing differentColor order" >
            
            <Col md={5} data-aos={"fade-up"} className="text-center item1" style={{marginTop: "25px"}}>
                <div className="titleProcess2">Rapid development</div>
                <div className="textPricing" >
                    With knowledge in multiple tech stacks we design and build products in less than a week depending on the project.
                </div>
            </Col>
            <Col  md={1}></Col>


            <Col md={6} data-aos={"fade-up"} className="text-center item2 heightRegis">
                <div className="simple-trans-main spacingSimple" onLoad={onClick} >
                {transitions.map(({ item, props, key }) => {
                    const Page = pages[item]
                    return <Page key={key} style={props} />
                })}
                </div>
            </Col>
 
        </Row>
    )
}


export default Pricing;